import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'

const getCSRFToken = () => {
  const element = document.querySelector('meta[name="csrf-token"]')
  return element ? element.getAttribute('content') : ''
}

const AlertTypeButton = ({ active, title, onClick }) => {
  return (
    <div style={{ marginTop: 10 }}>
      <Button active={active} variant="outline-secondary" size="sm" onClick={onClick}>
        {title}
      </Button>
    </div>
  )
}

export default function AlertFlow({ id }) {
  const [alertType, setAlertType] = useState(null)
  const [creating, setCreating] = useState(false)
  const [success, setSuccess] = useState(false)

  const createAlert = async () => {
    setCreating(true)
    try {
      const response = await fetch('/alerts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
        },
        body: JSON.stringify({
          alert: {
            class_session_id: id,
            alert_type: alertType,
          },
        }),
      })

      if (response.ok) {
        setSuccess(true)
      } else {
        alert('Failed to create alert')
      }
    } catch (error) {
      alert('Error creating alert')
    }
    setCreating(false)
  }

  if (success) {
    return (
      <div style={{ marginTop: 10 }}>
        <small className="text-secondary">We'll notify you when a spot becomes available!</small>
      </div>
    )
  }

  return (
    <div>
      <AlertTypeButton
        active={alertType === 'any_spot'}
        title="Any Spot"
        onClick={() => setAlertType('any_spot')}
      />
      <AlertTypeButton
        active={alertType === 'double_floor'}
        title="Double Floor"
        onClick={() => setAlertType('double_floor')}
      />
      {alertType && (
        <Button
          className="mt-3"
          variant="primary"
          size="sm"
          disabled={creating}
          onClick={createAlert}
        >
          {creating ? 'Creating...' : 'Confirm Alert?'}
        </Button>
      )}
    </div>
  )
}
